import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
export var toggleDeviceDetailsWindow = mutatorAction('toggleDeviceDetailsWindow', function () {
    var store = mobileDeviceFullStore();
    store.isDetailsOpen = !store.isDetailsOpen;
});
//# sourceMappingURL=toggleDeviceDetailsWindow.js.map